export const getPercentFromCountList = (countList) => {
  let totalSum = 0;
  countList.forEach((el) => (totalSum += el));
  let percentList = [];
  let percentListRounded = [];
  countList.forEach((el) => {
    if (el === 0 || totalSum === 0) {
      percentList.push(0);
    } else {
      percentList.push((el * 100) / totalSum);
    }
  });
  countList.forEach((el) => {
    if (el === 0 || totalSum === 0) {
      percentListRounded.push(0);
    } else {
      percentListRounded.push(Math.round((el * 100) / totalSum));
    }
  });

  let totalPercent = 0;
  percentListRounded.forEach((el) => (totalPercent += el));
  if (totalPercent === 0 || totalPercent === 100) {
    return percentListRounded;
  } else if (totalPercent > 100) {
    let roundDiff = [];
    let count = parseInt((totalPercent - 100).toString());
    percentList.forEach((el) => roundDiff.push(Math.round(el) - el));
    for (let i = 1; i <= count; i++) {
      let maxValue = Math.max.apply(Math, roundDiff);
      let maxValueIndex = roundDiff.findIndex((el) => el === maxValue);
      roundDiff[maxValueIndex] -= 1;
      percentListRounded[maxValueIndex] = Math.round(percentListRounded[maxValueIndex] - 1);
    }
    return percentListRounded;
  } else if (totalPercent < 100) {
    let roundDiff = [];
    percentList.forEach((el) => roundDiff.push(Math.round(el) - el));
    let count = Math.round(100 - totalPercent);
    for (let i = 1; i <= count; i++) {
      let minValue = Math.min.apply(Math, roundDiff);
      let minValueIndex = roundDiff.findIndex((el) => el === minValue);
      roundDiff[minValueIndex] += 1;
      percentListRounded[minValueIndex] = Math.round(percentListRounded[minValueIndex] + 1);
    }
    return percentListRounded;
  }

  return [];
};
